import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { SourcingDecisionWorkflowStatus } from '@/features/offerCostBudgets/constants/offerCostBudget.constant'
import useOfferList from '@/features/offers/hooks/useOfferList'
import { authSelector } from '@/stores/auth/authSlice'
import { Flex } from '@chakra-ui/react'
import BaseOfferTaskWidget from './BaseOfferTaskWidget'
import OfferTaskButton from './OfferTaskButton'

const MyCostBudgetWidget = () => {
  const { user } = useSelector(authSelector)

  const { useFetchOfferSourcingDecisions } = useOfferList()
  const { data: sourcingDecisionResponse } = useFetchOfferSourcingDecisions({
    page: 1,
    pageSize: 0,
    filters: {
      workflowStatus: SourcingDecisionWorkflowStatus.ACTION_REQUIRED,
    },
  })

  const shouldShowWidget = useMemo(() => {
    return sourcingDecisionResponse?.data && sourcingDecisionResponse.data.length > 0
  }, [sourcingDecisionResponse])

  const link = `/offers/sourcingDecisions?workflowStatus=${SourcingDecisionWorkflowStatus.ACTION_REQUIRED}`

  // if (!shouldShowWidget) {
  //   return <></>
  // }

  return (
    <BaseOfferTaskWidget title={'My Cost Budget'}>
      <Flex gap="5" direction={['column', 'row']} wrap="wrap">
        <OfferTaskButton
          color="teal"
          buttonText={'Action Required'}
          count={Array.isArray(sourcingDecisionResponse?.data) ? sourcingDecisionResponse?.data.length : 0}
          link={link}
        />
      </Flex>
    </BaseOfferTaskWidget>
  )
}

export default MyCostBudgetWidget
